import React from 'react';

interface ThemeFieldProps {
  themeId: string | null;
  themes: any[];
  onChange: (themeId: string | null) => void;
}

const ThemeField: React.FC<ThemeFieldProps> = ({ themeId, themes, onChange }) => {
  return (
    <div>
      <label className="block text-xs font-bold uppercase tracking-wider text-tinta">
        Tema do Sorteio
      </label>
      <select
        value={themeId || ''}
        onChange={(e) => onChange(e.target.value || null)}
        className="mt-1 block w-full bg-white border border-tinta/15 rounded-lg px-3 py-2.5 text-sm text-tinta placeholder:text-tinta-soft/70 placeholder:italic focus:outline-none focus:ring-2 focus:ring-bordo/40 focus:border-bordo transition-colors"
      >
        <option value="">Usar tema do Roda de Prêmios</option>
        {themes.map((theme) => (
          <option key={theme.id} value={theme.id}>
            {theme.name} {theme.is_default ? '(Padrão)' : ''}
          </option>
        ))}
      </select>
      <p className="mt-1 text-xs text-tinta-soft italic">
        Escolha um tema para personalizar cores, logo e fonte da roleta
      </p>
    </div>
  );
};

export default ThemeField;
